import { type FC, useState } from "react";
import { useQuery } from "react-query";
import { useTypedSelector } from "../../../../redux/store";
import { type UserResult } from "../../../../api/generated/data-contracts";
import { ChatService } from "../../../../api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import { CircularProgress } from "@mui/material";

export const ActiveChatUsers: FC = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const userJwt = useTypedSelector((state) => state.auth.value);

  const { data, isLoading } = useQuery<UserResult[]>({
    queryKey: ["getActiveUsers", userJwt, isOpen],
    queryFn: async () => {
      return ChatService.globalUsersList({
        headers: { Authorization: `Bearer ${userJwt}` }
      }).then((res) => res.data);
    },
    refetchOnWindowFocus: false
  });

  const handleSenderClick = (interlocutorId: string): void => {
    setIsOpen(false);
    navigate(`/chat/${interlocutorId}`);
  };

  return (
    <>
      <Button
        variant="outlined"
        color="info"
        onClick={() => {
          setIsOpen(true);
        }}
        startIcon={<GroupIcon />}
        sx={{
          color: "#ededed"
        }}
      >
        Start new dialogue
      </Button>

      <Dialog
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <DialogTitle>Active Chat Users</DialogTitle>

        <DialogContent>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <List>
              {data && data.length > 0 ? (
                data.map((user) => (
                  <ListItem
                    key={user.auth0Id}
                    button
                    onClick={() => {
                      handleSenderClick(user.auth0Id);
                    }}
                    style={{
                      overflowY: "auto"
                    }}
                  >
                    <ListItemText
                      primary={user.fullName}
                      style={{
                        marginLeft: "16px",
                        fontWeight: "bold",
                        color: "#1976d2"
                      }}
                    />
                  </ListItem>
                ))
              ) : (
                <p>No active users</p>
              )}
            </List>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setIsOpen(false);
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
